export const ContactsApi = {
  message: '/support/message',
};
